import { render, staticRenderFns } from "./linked-application-item.vue?vue&type=template&id=039e4480"
import script from "./linked-application-item.vue?vue&type=script&lang=js"
export * from "./linked-application-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports